//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Engraving from "./Engraving.vue";

export default {
  components: {
    Engraving,
  },
  props: {
    typeMaterial: {
      type: Array,
      default() {
        return []
      }
    },
    info: {
      type: Object,
      default() {
        return {}
      }
    },
    stoneIndex: {
      type: Number,
      default() {
        return 0
      }
    },
  },
  data() {
    return {
      margin: 0,
      disabled_next_attributes: [],
      engravingKeyInc: 0,
    }
  },
  watch: {
    'info.request_config': {
      handler() {
        this.setDisabledNextAttributes();
        this.engravingKeyInc++;
        if (!this.product.engraving) {
          this.removePendantEngravingQuery();
        }
      },
      immediate: true
    }
  },
  computed: {
    showInlay() {
      return this.materials.inlayList?.length > 1;
    },
    bootstrap() {
      return this.$store.getters.getBootstrap;
    },
    pendant() {
      return this.$route.query.configId.split(',')[this.stoneIndex + 1]
    },
    bails() {
      let c = this.$route.query.configId.split(',')[this.stoneIndex + 1].split('-')[0];
      let a = this.info.connected_products.find(item => item.default_config.configuration_id.includes(c));
      return a.connected_configs && a.connected_configs.bail ? a.connected_configs.bail : []
    },
    product() {
      let c = this.$route.query.configId.split(',')[this.stoneIndex + 1].split('-')[0] || '';
      return c ? this.info.connected_products.find(item => item.default_config.configuration_id.includes(c)) : '';
    },
    materials() {
      const vendor = this.$route.query.configId.split(',')[this.stoneIndex + 1].split('|')[0].split('-')[0];
      const prod = this.info.connected_products.find(item => item.default_config.configuration_id.split('-')[0] === vendor);
      const stones = [];

      const attr = [];

      for (const key in this.bootstrap.data.attributes) {
        attr.push(this.bootstrap.data.attributes[key])
      }

      const stoneTypes = prod ? [prod.attributes.filter(item => item.attribute_group === this.constAttributeGroups().stoneType).map(item => {
        return {...item, title: item.name}
      }), attr.filter(item => item.attribute_group === this.constAttributeGroups().stoneType2).map(item => {
        return {...item, title: item.name}
      })] : [];
      const stoneShapes = prod ? [prod.attributes.filter(item => item.attribute_group === this.constAttributeGroups().stoneCut || item.attribute_group === this.constAttributeGroups().symbols).map(item => {
        return {...item, title: item.name}
      }), attr.filter(item => item.attribute_group === this.constAttributeGroups().stoneCut2).map(item => {
        return {...item, title: item.name}
      })] : [];

      const symbols = prod ? prod.attributes.filter(item => item.attribute_group === this.constAttributeGroups().symbols).map(item => {
        return {...item, title: item.name}
      }) : [];

      const inlayList = prod ? prod.attributes.filter(item => item.attribute_group === this.constAttributeGroups().inlay).map(item => {
        return {...item, title: item.name}
      }) : [];

      const sizes = prod ? prod.attributes.filter(item => item.attribute_group === this.constAttributeGroups().ringSize).map(item => {
        return {...item, title: item.name}
      }) : [];

      const stoneShapesFirstStone = prod ? prod.attributes.filter(item => item.attribute_group === this.constAttributeGroups().stoneCut).map(item => {
        return {...item, title: item.name}
      }) : [];

      return {
        stoneTypes: stoneTypes,
        stoneShapes: stoneShapes,
        symbols: symbols,
        inlayList: inlayList,
        sizes: sizes,
        stoneShapesFirstStone: stoneShapesFirstStone
      }
    },
    isNecklaceThemesGroup() {
      return this.info.theme.id === this.constProductThemes().necklaceMain ||
        this.info.theme.id === this.constProductThemes().beadNecklace;
    },
    standardSizeInitialValue() {
      return this.getFormattedSizeValue(this.product.default_length_attribute.sku_part);
    },
    connectedProductOnlyStoneTypeThemesGroup() {
      return this.product?.theme?.id === this.constProductThemes().ringStoneMetalSize ||
        this.product?.theme?.id === this.constProductThemes().pendantStoneMetal;
    },
  },
  methods: {
    removePendantEngravingQuery() {
      const pendantEngravingIndex = this.stoneIndex + 1;
      const query = {...this.$route.query};
      if (query[`e${pendantEngravingIndex}_sub`] || query[`f${pendantEngravingIndex}_sub`]) {
        delete query[`e${pendantEngravingIndex}_sub`];
        delete query[`f${pendantEngravingIndex}_sub`];
        this.$router.replace({query});
      }
    },
    setDisabledNextAttributes() {
      const configurationId = this.$route.query.configId.split(',')?.[this.stoneIndex + 1]?.split('|')?.[0];
      this.disabled_next_attributes = this.info.request_config.find(item => item.configuration_id === configurationId)?.disabled_next_attributes || [];
    },
    changeBail(bail) {
      let temp = this.$route.query.configId.split(',');
      let t = temp[this.stoneIndex + 1].split('|')
      t[1] = bail.configuration_id;
      t = t.join('|')
      temp[this.stoneIndex + 1] = t;
      temp = temp.join(',');
      const query = {...this.$route.query, configId: temp};
      if (this.$route.query.configId !== query) {
        this.$router.replace({query}).catch(err => {});
      }
    },
    selectedProduct(el) {
      let arr = el.configuration_id.split('-');

      const stones = [];

      const attr = []

      for (const key in this.bootstrap.data.attributes) {
        attr.push(this.bootstrap.data.attributes[key])
      }

      const stoneTypes = [attr.filter(item => item.group_id === 3).map(item => {
        return {...item, title: item.name}
      }), attr.filter(item => item.group_id === 9).map(item => {
        return {...item, title: item.name}
      })];
      const stoneShapes = [attr.filter(item => item.group_id === 4 || item.group_id === 11).map(item => {
        return {...item, title: item.name}
      }), attr.filter(item => item.group_id === 5).map(item => {
        return {...item, title: item.name}
      })];

      const symbols = attr.filter(item => item.group_id === 11).map(item => {
        return {...item, title: item.name}
      });
      arr.forEach((item, i) => {
        if (i && i < (arr.length - 1)) {
          const a = {};
          if (stoneShapes[0]
            && stoneShapes[0].some(item => item.sku_part === arr[i].substr(0, 2))) {
            a.ss = stoneShapes.find(item => item.sku_part === arr[i].substr(0, 2))
          } else if (symbols && symbols.some(item => item.sku_part === arr[i])) {
            a.ss = symbols.find(item => item.sku_part === arr[i])
          }
          if (stoneTypes[0]
            && stoneTypes[0].some(item => item.sku_part === arr[i].substr(2))) {
            a.st = stoneTypes[0].find(item => item.sku_part === arr[i].substr(2))
          } else if (symbols && symbols.some(item => item.sku_part === arr[i])) {
            a.st = symbols.find(item => item.sku_part === arr[i])
          }
          stones.push(a)
        }
      })
      return {
        stones,
        m: this.typeMaterial.find(item => item.value === arr[arr.length - 1])
      }
    },
    checkAndReplaceSubItemEngraving(query, i) {
      delete query[`e${i}_sub`];
      delete query[`f${i}_sub`];
      if (query[`e${this.stoneIndex + 1}_sub`] || query[`f${this.stoneIndex + 1}_sub`]) {
        query[`e${i}_sub`] = query[`e${this.stoneIndex + 1}_sub`];
        query[`f${i}_sub`] = query[`f${this.stoneIndex + 1}_sub`];
      }
      delete query[`e${this.stoneIndex + 1}_sub`];
      delete query[`f${this.stoneIndex + 1}_sub`];
    },
    // changeIndex(i) {
    //   if (i === (this.stoneIndex + 1)) {
    //     return;
    //   }
    //   let arr = this.$route.query.configId.split(',');
    //   arr[i] = arr[this.stoneIndex + 1];
    //   arr[this.stoneIndex + 1] = '';
    //   const query = {...this.$route.query, configId: arr.join(',')};
    //   this.checkAndReplaceSubItemEngraving(query, i);
    //   this.$router.replace({query}).catch(err => {});
    //   this.$parent.$emit('editStone', i - 1);
    // },
    changeInlay(item) {
      const materialSplitUrlPosition = 2;
      let arr = this.$route.query.configId.split(',');
      let temp = arr[this.stoneIndex + 1].split('|')
      let temp2 = temp[0].split('-');
      temp2[materialSplitUrlPosition] = item.value;
      temp[0] = temp2.join('-');
      arr[this.stoneIndex + 1] = temp.join('|');
      const query = {...this.$route.query, configId: arr.join(',')};
      if (this.$route.query.configId !== query) {
        this.$router.replace({query}).catch(err => {});
      }
    },
    changeST(item, i) {
      const materialSplitUrlPosition = 1;
      let arr = this.$route.query.configId.split(',');
      let temp = arr[this.stoneIndex + 1].split('|')
      let temp2 = temp[0].split('-');
      temp2[materialSplitUrlPosition] = this.connectedProductOnlyStoneTypeThemesGroup ? item.value : temp2[materialSplitUrlPosition].substr(0, 2) + item.value;
      temp[0] = temp2.join('-');
      arr[this.stoneIndex + 1] = temp.join('|');
      const query = {...this.$route.query, configId: arr.join(',')};
      if (this.$route.query.configId !== query) {
        this.$router.replace({query}).catch(err => {});
      }
    },
    changeSS(item) {
      const materialSplitUrlPosition = 1;
      let arr = this.$route.query.configId.split(',');
      let temp = arr[this.stoneIndex + 1].split('|');
      let temp2 = temp[0].split('-');
      temp2[materialSplitUrlPosition] = item.value + temp2[materialSplitUrlPosition].substr(2);
      temp[0] = temp2.join('-');
      arr[this.stoneIndex + 1] = temp.join('|');
      const query = {...this.$route.query, configId: arr.join(',')};
      if (this.$route.query.configId !== query) {
        this.$router.replace({query}).catch(err => {});
      }
    },
    changeSize(item) {
      let arr = this.$route.query.configId.split(',');
      let temp = arr[this.stoneIndex + 1].split('|')
      let temp2 = temp[0].split('-');
      temp2[temp2.length - 1] = item.value;
      temp[0] = temp2.join('-');
      arr[this.stoneIndex + 1] = temp.join('|');
      const query = {...this.$route.query, configId: arr.join(',')};
      if (this.$route.query.configId !== query) {
        this.$router.replace({query}).catch(err => {});
      }
    },
    getFormattedSizeValue(value) {
      if (typeof value === 'number' || value.search('LEN') === -1) {
        return Number(value);
      }
      const sizeDefiningNumber = this.isNecklaceThemesGroup ? 100 : 10;
      value = value.replace('LEN', '');
      value = Number(value);
      if (value < sizeDefiningNumber) {
        value *= 10;
      }
      return value;
    },
  }
}
